'use client';

import { AlertUsers } from '@/components/AlertUsers';
import { RepairForm } from './components/RepairForm';

export default function Page() {
	return (
		<section className="flex grow flex-col">
			<AlertUsers />
			<RepairForm />
		</section>
	);
}
